import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import {
  ActivatedRoute,
  Router
} from '@angular/router';

import { UsuarioService } from 'src/app/services/usuario.service';
import { Usuario } from 'src/app/models/usuario.model';

@Component({
  selector: 'app-admin-session',
  templateUrl: './admin-session.component.html',
  styleUrls: ['./admin-session.component.css']
})
export class AdminSessionComponent implements OnInit, OnDestroy {

  private openerOrigin: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private usuarioService: UsuarioService
  ) {}

  ngOnInit(): void {

    console.log(
      '[AdminSession] Componente iniciado'
    );

    // ==========================================
    // LIMPIAR SESIÓN HEREDADA
    // ==========================================

    //sessionStorage.clear();
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('usuario');

    // ==========================================
    // OBTENER ORIGEN ADMIN
    // ==========================================

    this.openerOrigin =
      this.route.snapshot.queryParamMap.get(
        'openerOrigin'
      ) || '';

    console.log(
      '[AdminSession] openerOrigin:',
      this.openerOrigin
    );

    if (!this.openerOrigin) {

      this.router.navigate(
        ['/login'],
        {
          replaceUrl: true
        }
      );

      return;
    }

    // ==========================================
    // ESCUCHAR SESIÓN
    // ==========================================

    window.addEventListener(
      'message',
      this.receiveSession
    );

    // ==========================================
    // AVISAR AL ADMIN
    // ==========================================

    if (window.opener) {

      window.opener.postMessage(
        {
          type: 'ADMIN_SESSION_READY'
        },
        this.openerOrigin
      );

    }
  }

  ngOnDestroy(): void {

    window.removeEventListener(
      'message',
      this.receiveSession
    );

  }

  private receiveSession = (
    event: MessageEvent
  ) => {

    console.log(
      '[AdminSession] Mensaje recibido:',
      event.data
    );

    console.log(
      '[AdminSession] Origin recibido:',
      event.origin
    );

    console.log(
      '[AdminSession] Origin esperado:',
      this.openerOrigin
    );

    if (
      event.origin !==
      this.openerOrigin
    ) {

      console.warn(
        '[AdminSession] Origin rechazado'
      );

      return;
    }

    if (
      event.data?.type !==
      'ADMIN_SESSION_INIT'
    ) {

      console.warn(
        '[AdminSession] Tipo de mensaje incorrecto:',
        event.data?.type
      );

      return;
    }

    const session =
      event.data?.session;

    console.log(
      '[AdminSession] Sesión recibida:',
      session
    );

    if (
      !session ||
      !session.token ||
      !session.use_id
    ) {

      console.error(
        '[AdminSession] Sesión inválida'
      );

      return;
    }

    this.crearSesion(session);
  };

  private crearSesion(session: any) {

    console.log(
      '[AdminSession] Creando sesión:',
      session
    );

    // ==========================================
    // 1. ELIMINAR SESIÓN HEREDADA DEL ADMIN
    // ==========================================

    /*
    * La nueva ventana puede recibir inicialmente
    * una copia del sessionStorage del administrador.
    *
    * Eliminamos solamente los datos correspondientes
    * a la identidad del usuario.
    */
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('usuario');

    // ==========================================
    // 2. CREAR USUARIO
    // ==========================================

    const usuario = new Usuario(
      session.use_name,
      session.use_rut
    );

    usuario.user =
      session.use_username;

    usuario._id =
      session.use_id;

    usuario.nombre_usuario =
      `${session.use_name || ''} ` +
      `${session.use_paternal_surname || ''} ` +
      `${session.use_maternal_surname || ''}`.trim();

    usuario.use_name =
      session.use_name;

    usuario.use_paternal_surname =
      session.use_paternal_surname;

    usuario.use_maternal_surname =
      session.use_maternal_surname;

    usuario.email =
      session.use_email;

    usuario.typ_id =
      session.use_typ_id;

    usuario.typ_name =
      session.use_typ_name;

    usuario.use_sta_id =
      session.use_sta_id;

    usuario.doc_id =
      session.doc_id;

    usuario.doc_lme =
      session.doc_lme;

    usuario.telefono =
      session.use_telefono;

    usuario.doc_check_modal_vl =
      session.doc_check_modal_vl;

    usuario.doc_enrolled =
      session.doc_enrolled;

    usuario.doc_ondemand =
      session.doc_ondemand;

    usuario.doc_check_can_self_schedule =
      session.doc_check_can_self_schedule;

    usuario.doc_check_can_use_digital_pad =
      session.doc_check_can_use_digital_pad;

    usuario.doc_check_can_create_orders =
      session.doc_check_can_create_orders;

    usuario.doc_check_can_create_prescriptions =
      session.doc_check_can_create_prescriptions;

    usuario.doc_check_can_create_certificates =
      session.doc_check_can_create_certificates;

    // ==========================================
    // 3. GUARDAR TOKEN + USUARIO
    // ==========================================

    this.usuarioService.guardarStorage(
      session.token,
      usuario,
      false
    );

    // ==========================================
    // 4. VARIABLES QUE CREA EL LOGIN NORMAL
    // ==========================================

    sessionStorage.setItem(
      'zoom_up_med',
      'false'
    );

    sessionStorage.setItem(
      'zoom_ud_video',
      'false'
    );

    // ==========================================
    // 5. LOGS TEMPORALES
    // ==========================================

    console.log(
      '[AdminSession] Usuario guardado:',
      usuario
    );

    console.log(
      '[AdminSession] Token:',
      sessionStorage.getItem('token')
    );

    console.log(
      '[AdminSession] Usuario storage:',
      sessionStorage.getItem('usuario')
    );

    // ==========================================
    // 6. DESCONECTAR DEL ADMIN
    // ==========================================

    try {
      window.opener = null;
    } catch (error) {
      console.warn(
        '[AdminSession] No fue posible limpiar window.opener'
      );
    }

    // ==========================================
    // 7. DASHBOARD
    // ==========================================

    this.router.navigate(
      ['/dashboard'],
      {
        replaceUrl: true
      }
    ).then(() => {

      /*
      * Necesario para reconstruir:
      *
      * - menú
      * - header
      * - permisos
      * - servicios
      *
      * usando el usuario impersonado.
      */
      window.location.reload();

    });

  }

}